import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-tabpanels'
};

export default BaseStyle.extend({
    name: 'tabpanels',
    classes
});
